import { render, staticRenderFns } from "./ThumbnailHolder.vue?vue&type=template&id=ceb0adcc&scoped=true&"
import script from "./ThumbnailHolder.vue?vue&type=script&lang=js&"
export * from "./ThumbnailHolder.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailHolder.vue?vue&type=style&index=0&id=ceb0adcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb0adcc",
  null
  
)

export default component.exports